import { Button, Checkbox, CircularProgress, Divider, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { useRef, useEffect, useState } from 'react';
import '../css/modal.css'

// Permission codes stored comma-separated in emp_role_id. Keep in sync with
// menuitems.js and the role checks inside pages.
const roleOptions = [
    { code: '101', label: 'Компани' },
    { code: '102', label: 'Харилцагч' },
    { code: '103', label: 'Брэнд' },
    { code: '104', label: 'Урамшуулал, хямдрал' },
    { code: '105', label: 'Бүтээгдэхүүн' },
    { code: '106', label: 'Захиалга' },
    { code: '107', label: 'Гүйлгээ' },
    { code: '108', label: 'Өдрийн нэгтгэл тайлан' },
    { code: '109', label: 'Захиалга нэгтгэл тайлан' },
    { code: '110', label: 'Захиалга тайлан' },
    { code: '111', label: 'Захиалга тайлан бүгд' },
    { code: '112', label: 'Зээлийн түүх' },
    { code: '113', label: 'Зээлийн төлөлт' },
    { code: '114', label: 'Бүтээгдэхүүний үнэ засах' },
    { code: '115', label: 'Үлдэгдэл засах, буцаалт' },
    { code: '116', label: 'Хүргэлт буцаах' },
    { code: '117', label: 'Зээл буцаах' },
    { code: '118', label: 'Ажилтан' },
];

const splitList = (v) => (v || '').split(',').map((s) => s.trim()).filter((s) => s !== '');

const EmployeeMod = ({ handleClose, token, open, emprow, handleModal, handleRefresh }) => {

    const emp_lastname = useRef();
    const emp_firstname = useRef();
    const phone_number = useRef();
    const bank_account = useRef();
    const password = useRef();
    const [prodload, setProdload] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [owncomp, setOwncomp] = useState(splitList(emprow.own_company_id));
    const [roles, setRoles] = useState(splitList(emprow.emp_role_id));

    const handleEscape = (e) => {
        if (e.keyCode == 27) {
            handleClose(false);
        }
    }

    useEffect(() => {
        emp_lastname.current.value = emprow.emp_lastname || "";
        emp_firstname.current.value = emprow.emp_firstname || "";
        phone_number.current.value = emprow.phone_number || "";
        bank_account.current.value = emprow.bank_account || "";

        window.addEventListener('keyup', handleEscape);
        return () => {
            window.removeEventListener('keyup', handleEscape);
        }

    }, [handleEscape])

    useEffect(() => {
        const request = new Request('https://wms-cloud.com/api/Company', {
        //const request = new Request('http://localhost:8080/Company', {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` })
        });
        fetch(request).then((response) => {
            if (response.status == 200) {
                return response.json();
            }
        }).then((resp) => {
            setCompanies(resp || []);
        });
    }, [])

    // Codes already saved on the employee but missing from the lists above
    // are still shown, so saving never silently drops them.
    const compLabel = (id) => {
        const c = companies.find((e) => String(e.com_id) === id);
        return c ? c.com_name : id;
    }
    const roleLabel = (code) => {
        const r = roleOptions.find((e) => e.code === code);
        return r ? r.label : code;
    }
    const compChoices = [...companies.map((e) => String(e.com_id)), ...owncomp.filter((id) => !companies.some((e) => String(e.com_id) === id))];
    const roleChoices = [...roleOptions.map((e) => e.code), ...roles.filter((c) => !roleOptions.some((e) => e.code === c))];

    const handleClick = () => {
        if (open) {
            handleModal(false);
        }
    }

    const handleSubmit = () => {
        setProdload(true);
        var req = {
            'emp_lastname': emp_lastname.current.value,
            'emp_firstname': emp_firstname.current.value,
            'phone_number': phone_number.current.value,
            'bank_account': bank_account.current.value,
            'own_company_id': owncomp.join(','),
            'emp_role_id': roles.join(','),
            'password': password.current.value
        }

        const request = new Request('https://wms-cloud.com/api/Employee/'+emprow.id , {
        //const request = new Request('http://localhost:8080/Employee/'+emprow.id , {
            method: 'PUT',
            body: JSON.stringify(req),
            headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${token}` })
        });

        fetch(request).then((response) => {
            if (response.status == 200) {
                setProdload(false);
                handleClose(false);
                handleRefresh();

            } else {
                console.log("aldaa garsan" + JSON.stringify(response));
                alert("Амжилтгүй " + response.status);
                setProdload(false);
            }
        });
    }

    return <div className="custmodal" >
    <div className="mcont">
        <div className="mheader">
            Ажилтан засах
        <button aria-label="Хаах" onClick={() => handleClick()}>✕</button>
        </div>
        <Divider />
        <div className="mccont">
                <div className="crow">
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField value={emprow.emp_id || ""} label="Ажилтны код" fullWidth disabled ></TextField>
                    </div>
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField value={emprow.username || ""} label="Нэвтрэх нэр" fullWidth disabled ></TextField>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={emp_lastname} label="Овог" fullWidth ></TextField>
                    </div>
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={emp_firstname} label="Нэр" fullWidth ></TextField>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={phone_number} label="Утас" fullWidth ></TextField>
                    </div>
                    <div style={{ width: "50%", paddingRight: "10px" }}>
                        <TextField inputRef={bank_account} label="Дансны дугаар" fullWidth ></TextField>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <FormControl fullWidth>
                            <InputLabel id="emp-owncomp-label">Хамааралтай компани</InputLabel>
                            <Select
                                labelId="emp-owncomp-label"
                                multiple
                                value={owncomp}
                                onChange={(e) => setOwncomp(e.target.value)}
                                input={<OutlinedInput label="Хамааралтай компани" />}
                                renderValue={(sel) => sel.map(compLabel).join(', ')}
                            >
                                {compChoices.map((id) => (
                                    <MenuItem key={id} value={id}>
                                        <Checkbox checked={owncomp.includes(id)} />
                                        <ListItemText primary={compLabel(id)} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <FormControl fullWidth>
                            <InputLabel id="emp-role-label">Эрх</InputLabel>
                            <Select
                                labelId="emp-role-label"
                                multiple
                                value={roles}
                                onChange={(e) => setRoles(e.target.value)}
                                input={<OutlinedInput label="Эрх" />}
                                renderValue={(sel) => sel.map(roleLabel).join(', ')}
                            >
                                {roleChoices.map((code) => (
                                    <MenuItem key={code} value={code}>
                                        <Checkbox checked={roles.includes(code)} />
                                        <ListItemText primary={roleLabel(code)} secondary={code} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="crow">
                    <div style={{ width: "100%", paddingRight: "10px" }}>
                        <TextField inputRef={password} type="password" autoComplete="new-password" label="Шинэ нууц үг" helperText="Хоосон үлдээвэл нууц үг өөрчлөгдөхгүй" fullWidth ></TextField>
                    </div>
                </div>
        </div>

        <div className="mfooter">
            <Button onClick={handleClick}>Буцах</Button>
            <Button variant="contained" onClick={handleSubmit}>Хадгалах</Button>
        </div>
        {prodload ?
            <div className="prodload">
                <CircularProgress />
            </div> : ""
        }
    </div>
    </div>

}

export default EmployeeMod;
